module.exports = __webpack_public_path__ + "img/testimonials-shape.6d18a99a.png";